var lipSync = {
  mounted: function mounted() {
    this.lipSyncConnection = null;
    this.player = null;
    this.lipSyncPageId = 0;
    this.maxLatency = 0;
  },
  methods: {
    startLipSync: function startLipSync(player) {
      this.player = player;
      this.isAudio = player.nodeName === 'AUDIO';
      console.log('lipsync player:', this.player);
      var maxLipsyncLatency = this.$xp.settings.mergedSettings.maxLipsyncLatency;
      this.maxLatency = this.isAudio ? maxLipsyncLatency.audio : maxLipsyncLatency.video;
      console.log('lipsync max latency: ' + this.maxLatency);
      this.lipSyncPageId = parseInt(this.$route.params.id);
      this.retryConnect = 0;
      this.connectLipSyncServer();
    },
    stopLipSync: function stopLipSync() {
      if (this.lipSyncConnection) {
        this.lipSyncConnection.close();
      }
    },
    connectLipSyncServer: function connectLipSyncServer() {
      var _this = this;

      this.ntpOffset = 9999999999;
      this.ntpCount = 0;
      this.deltaPlayPos = 0;
      this.seekLatency = this.isAudio ? 230 : 1200; // preset value

      this.seekLatencyHistory = [this.seekLatency];
      this.retryConnect++;
      var url = this.lipSyncUrl;

      if (url.match(/<servername>/)) {
        var baseUrl = this.$xp.settings.baseUrl;
        var matches = /^http.?:\/\/([^/]+)\/.*$/.exec(baseUrl);

        if (matches) {
          url = url.replace(/<servername>/, matches[1]);
        }
      }

      this.lipSyncConnection = new WebSocket(url);
      this.syncing = true;
      this.seekLatencyIgnoreFirst = true;

      this.lipSyncConnection.onopen = function (e) {
        _this.onConnectionOpen(e);
      };

      this.lipSyncConnection.onerror = function (e) {
        _this.onConnectionError(e);
      };

      this.lipSyncConnection.onmessage = function (e) {
        _this.onConnectionMessage(e);
      };

      this.lipSyncConnection.onclose = function (e) {
        _this.onConnectionClose(e);
      };
    },
    onConnectionOpen: function onConnectionOpen(e) {
      this.sendNtpReq();
    },
    onConnectionError: function onConnectionError(e) {
      if (this.lipSyncConnection) {
        this.lipSyncConnection.close();
        this.lipSyncConnection = null;
      }

      if (this.retryConnect < 10) {
        var self = this;
        setTimeout(function () {
          self.connectLipSyncServer();
        }, 1000);
      }
    },
    sendNtpReq: function sendNtpReq() {
      var data = {
        Type: 'NTP',
        Req: Date.now(),
        PageID: parseInt(this.$route.params.id)
      };
      this.lipSyncConnection.send(JSON.stringify(data));
    },
    onConnectionMessage: function onConnectionMessage(e) {
      var data = null;

      try {
        data = JSON.parse(e.data);
      } catch (e) {
        console.log(e);
      }

      if (data) {
        switch (data.Type) {
          case 'NTP':
            this.onNtpMessage(data);
            break;

          case 'POS':
            if (!this.syncing) {
              this.onPosMessage(data);
            }

            break;
        }
      }
    },
    onNtpMessage: function onNtpMessage(data) {
      // check if this is the right page for the current video
      var currentPageId = parseInt(this.$route.params.id);

      if (currentPageId !== this.lipSyncPageId) {
        this.stopLipSync();
      } else if (data.PageID !== null && data.PageID !== this.lipSyncPageId) {
        console.log('lipsync: redirect to page ' + data.PageID);
        this.stopLipSync();
        this.$router.replace({
          path: '/page/' + data.PageID,
          query: {
            replace: true
          }
        });
      }

      var now = Date.now();
      var offset = Math.round(now - data.Timestamp + (now - data.Req) / 2);
      this.ntpCount++;

      if (offset < this.ntpOffset) {
        this.ntpOffset = offset;
        console.log('ntpOffset=' + this.ntpOffset);
      }

      if (this.ntpCount < 10) {
        this.sendNtpReq();
      } else {
        this.syncing = false;
      }
    },
    onPosMessage: function onPosMessage(data) {
      var _this2 = this;

      // check if this is the right page for the current video
      var currentPageId = parseInt(this.$route.params.id);

      if (currentPageId !== this.lipSyncPageId) {
        this.stopLipSync();
      } else if (data.PageID !== null && data.PageID !== this.lipSyncPageId) {
        this.$router.replace({
          path: '/page/' + data.PageID,
          query: {
            replace: true
          }
        });
      }

      if (!this.ready) {
        if (this.autoPlay) {
          // if (this.video) { this.video.play() } else if (this.sound) { this.sound.play() }
          this.player.play();
        }

        this.ready = true;
      }

      var now = Date.now() - this.ntpOffset;
      var currentDelta = now - this.player.currentTime * 1000;
      this.deltaPlayPos = data.DeltaPlayPos;

      if (this.player.paused || Math.abs(currentDelta - this.deltaPlayPos) > this.maxLatency) {
        this.player.currentTime = (now - this.deltaPlayPos + this.seekLatency) / 1000;
        setTimeout(function () {
          var now = Date.now() - _this2.ntpOffset;

          var currentDelta = now - _this2.player.currentTime * 1000;
          var seekLatency = currentDelta - _this2.deltaPlayPos;

          _this2.setSeekLatency(seekLatency);
        }, 400);
        console.log('SET DD:' + (currentDelta - this.deltaPlayPos) + ', deltaPlayPos:' + this.deltaPlayPos + ', currentDelta:' + currentDelta + ', latency:' + (currentDelta - this.deltaPlayPos));
      }
    },
    onConnectionClose: function onConnectionClose() {
      this.retryConnect = 0;
      this.player.pause();
    },
    setSeekLatency: function setSeekLatency(newValue) {
      if (this.seekLatencyIgnoreFirst) {
        this.seekLatencyIgnoreFirst = false;
      } else {
        if (Math.abs(newValue) < 500) {
          var seekLatency = Math.floor(newValue + this.seekLatency);
          this.seekLatencyHistory.push(seekLatency);
          if (this.seekLatencyHistory.length > 5) this.seekLatencyHistory.shift();
          var sum = 0;
          var div = 0;

          for (var i = 0; i < this.seekLatencyHistory.length; i++) {
            sum += this.seekLatencyHistory[i] * (i + 1);
            div += i + 1;
          }

          console.log('seekLatencyHistory:' + this.seekLatencyHistory);
          this.seekLatency = Math.floor(sum / div);
          console.log('correct seekLatency(' + newValue + ') => ' + this.seekLatency);
        } else {
          console.warn('seekLatency:' + (this.seekLatency + newValue));
        }
      }
    }
  }
};

export { lipSync as l };
